import styled from 'styled-components'
import device from '../../utilities/device'

type SectionHeaderProps = {
  light?: boolean
  center?: boolean
}

const SectionHeader = styled.h2<SectionHeaderProps>`
  /* Dark or light options */
  color: ${props =>
    props.light ? props.theme.colorWhite : props.theme.colorDarkBlue};
  text-align: ${props => (props.center ? 'center' : 'left')};
  @media ${device.laptop} {
    text-align: center;
  }
`

export default SectionHeader
